export enum FittingDefaultReturnCodes{
    SetAsDefault = 0,
    RemoveAsDefault = 1,
    NotAvailable = 2,
    NoSystemDef = 3,
    Error = 4,
}